import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import classnames from 'classnames/bind';
import { dispatchOpenQuestion } from 'containers/Report/utils/reportActivityEvents';
import styles from './ReportActivity.module.scss';

const cn = classnames.bind(styles);

const QUESTION_LABEL_MAX_LENGTH = 40;

const truncateLabel = (label) => {
  if (!label) return label;
  if (label.length <= QUESTION_LABEL_MAX_LENGTH) return label;
  return `${label.slice(0, QUESTION_LABEL_MAX_LENGTH).trimEnd()}…`;
};

const ReportActivityRow = ({ log, currentUser }) => {
  const hasGroup = !!log.pig_group;
  const messageId = hasGroup
    ? 'container.report.activity.correctedWithGroup'
    : 'container.report.activity.corrected';
  const isAuthor = !!currentUser?.id && !!log.user?.id && currentUser.id === log.user.id;

  const handleQuestionClick = (event) => {
    event.preventDefault();
    if (!log.svr_question_id) return;
    dispatchOpenQuestion(log.svr_question_id);
  };

  const questionLabel = log.question_label || null;
  const truncatedLabel = truncateLabel(questionLabel);
  const isTruncated = questionLabel && truncatedLabel !== questionLabel;
  const questionNode = questionLabel ? (
    <a
      className={cn('question-link')}
      title={isTruncated ? questionLabel : undefined}
      onClick={handleQuestionClick}
    >
      <strong>{truncatedLabel}</strong>
    </a>
  ) : (
    <a className={cn('question-link')} onClick={handleQuestionClick}>
      <strong><FormattedMessage id="container.report.activity.item" /></strong>
    </a>
  );

  const userNode = (
    <strong>
      {isAuthor
        ? <FormattedMessage id="general.you" />
        : log.user?.full_name}
    </strong>
  );

  const values = {
    user: userNode,
    question: questionNode,
    group: hasGroup ? <strong>{log.pig_group.name}</strong> : null,
  };

  return (
    <div className={cn('row')}>
      <div className={cn('text')}>
        <FormattedMessage id={messageId} values={values} />
      </div>
      <div className={cn('date')}>
        {moment(log.created_at).format('MMMM D, YYYY, h:mm A')}
      </div>
    </div>
  );
};

ReportActivityRow.propTypes = {
  log: T.shape({
    id: T.oneOfType([T.string, T.number]).isRequired,
    created_at: T.string.isRequired,
    svr_question_id: T.oneOfType([T.string, T.number]),
    question_label: T.string,
    user: T.shape({
      id: T.oneOfType([T.string, T.number]),
      full_name: T.string,
    }),
    pig_group: T.shape({
      id: T.oneOfType([T.string, T.number]),
      name: T.string,
    }),
  }).isRequired,
  currentUser: T.object,
};

export default connect((state) => ({
  currentUser: state.auth.user,
}))(ReportActivityRow);
